export default __webpack_public_path__ + "locales/ar-SA/ConnectDialog.json?hash=368243bc2ee99381760a22964f2c1bc0";